<template>
  <v-card width="100%">

    <div class="barometer-wrapper">
      <div class="barometer-header">
        <h2 v-if="selectedDataView == 'months' || (selectedDataView == 'weeks' && compDataView == 'monthly')">Maandelijkse doelstelling</h2>
        <h2 v-if="selectedDataView == 'fourweeks' || selectedDataView == 'weeks' && compDataView == 'fourweeks'">Doelstelling 4 weken</h2>
        <h3 v-if="selectedDataView == 'months' || (selectedDataView == 'weeks' && compDataView == 'monthly')">
          <span v-for="(month, index) in months" :key="index">
            <span v-if="month.id == selectedDataMonths"> {{ month.name }}</span>
          </span>
        </h3>
        <h3 v-if="selectedDataView == 'fourweeks' || selectedDataView == 'weeks' && compDataView == 'fourweeks'">
          week {{(selectedDataFourWeeks * 4) - 3 }} t/m {{(selectedDataFourWeeks * 4)}}
        </h3>
      </div>

      <div class="barometer-canvas-wrapper">
        <canvas :id="canvasID" generateGradient="false" width="210" height="140" ></canvas>
      </div>
      <div v-if="target" class="barometer-footer">
        <p class="barometer-rate ma-0"><span v-if="rate > 100" class="on-fire"></span> {{rate.toFixed(1)}}%</p>
        <p v-if="useManualGoals" class="barometer-description">De doelstelling is <b>€{{target}}</b></p>
        <p v-else class="barometer-description">Doelstelling is om <b> {{target}}% </b> hoger te zitten t.o.v. vorig jaar</p>
      </div>

      <div class="barometer-footer" v-else>
        <p class="barometer-rate ma-0"> 0%</p>
        <div class="barometer-alert">
          <v-alert :value="true" type="warning">
            Er is nog geen data of geen doel ingesteld.
          </v-alert>
         </div>
      </div>

    </div>
  </v-card>
</template>

<script>
import { bus } from "../../main";
import moment from "moment"

export default {
  props: ["level", "marks", "aperture", "colorStop", "colorStart", "colorPrimary", "canvasID", "rate", "weeknr", "target",
    "selectedDataView",
    "compDataView",
    "selectedDataWeek",
    "selectedDataMonths",
    "selectedDataFourWeeks",
    "months",
    "useManualGoals"],
  name: "gauge4weekstotal",
  data: () => ({
    mini: true,
    id: null, //passed getal door
    canvasRender: null,
    weekblock: null,
    weeknummer: null,
    opts: {
      angle: -0.1, /// The span of the gauge arc
      lineWidth: 0.26, // The line thickness
      pointer: {
        length: 0.7, // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#767676"
      },

      colorStop: "#333",
      colorStart: "#333",
      limitMax: true, // If false, max value increases automatically if value > maxValue
      // generateGradient: true,
      highDpiSupport: true,

      strokeColor: "rgb(204,204,204)",
      // percentColors: [[0.0, "#a9d70b"], [0.5, "#f9c802"], [1.0, "#ff0000"]],
      // staticZones: [
      //   { strokeStyle: "rgb(204,204,204)", min: 0, max: 120, height: 1.0 },
      //   { strokeStyle: "rgb(255,255,255)", min: 99, max: 100, height: 1.2 }
      // ],

      staticLabels: {
        font: "14px sans-serif", // Specifies font
        labels: [25, 50, 75, 100], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0 // Optional: Numerical precision. 0=round off.
      },
      staticZones: []
      // pointer: {
      //   // Extra optional pointer options:
      //   iconPath: "myicon.png", // Icon image source
      //   iconScale: 1, // Size scaling factor
      //   iconAngle: 90.0 // Rotation offset angle, degrees
      // }
    }
  }),

  created() {
    bus.$on("salonBarometerUpdate", this.updateData);
    if (this.colorStop + "1)" && this.colorStart + "1)") {
      this.opts.colorStop = this.colorStop + "1)";
      this.opts.colorStart = this.colorStart + "1)";
      this.opts.staticZones.push(
      //   { strokeStyle: this.colorStart + "0.25)", min: 0, max: 25 },
      //   { strokeStyle: this.colorStart + "0.50)", min: 25, max: 50 },
      //   { strokeStyle: this.colorStart + "0.75)", min: 50, max: 75 },
      //   { strokeStyle: this.colorStart + "1)", min: 75, max: 100 },
      //   { strokeStyle: this.colorPrimary + "1)" , min: 100, max: 120 },
        { strokeStyle: "#ff0a0a", min: 0, max: 25 },
        { strokeStyle: "#f2ce02", min: 25, max: 50 },
        { strokeStyle: "#ebff0a", min: 50, max: 75 },
        { strokeStyle: "#85e62c", min: 75, max: 100 },
        { strokeStyle: "#209c05", min: 100, max: 120},
       )
    }
  },

  mounted() {
    this.updateData();
  },

  methods: {
    updateData() {
      // console.log("4 Weeks barometer: ", this.rate)
      // var opts = this.opts;
      var target = document.getElementById(this.canvasID); // Passeren langs DOM element
      var gauge = new Gauge(target).setOptions(this.opts); // Unieke Gauge opbouwn

      gauge.maxValue = 120; // max gauge value
      gauge.setMinValue(0); // min value
      // gauge.set(this.rate); // actual value

      gauge.set(this.rate); // actual valu0;
      this.weekblock = Math.ceil(moment().week() / 4);
    }
  },

  computed: {
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    }
  }
};
</script>
